<template>
  <div
    v-if="summary"
    class="marathon-summary-wrapper"
    :class="[summaryOpen ? 'summary-open' : '']"
    :style="{
      'background-image':
        summary.gameType === 15
          ? 'linear-gradient(182deg, #ffa959 -23.76%, #ae4726 86.73%)'
          : summary.gameType === 18
          ? 'linear-gradient(81deg, #ae23a6, #e82762 98%)'
          : 'linear-gradient(81deg, #ea4c89, #e47b49 98%)',
    }"
  >
    <div class="marathon-summary-wrapper-collapsible" @click="showSummary">
      <VueText sizeLevel="5" weightLevel="5">{{ summary.surveyName }}</VueText>
      <VueIcon
        class="marathon-summary-wrapper-collapsible-caret"
        :class="[summaryOpen ? 'caret-down' : '']"
        :width="icons.right.width"
        :height="icons.right.height"
        :iconName="icons.right.name"
        color="#ffffff"
      ></VueIcon>
    </div>
    <div class="summary-area">
      <ul class="summary-area-list">
        <li>
          <VueText sizeLevel="4">Sıralaman</VueText>
          <VueText sizeLevel="4">{{ summary.rank }}</VueText>
        </li>
        <li>
          <VueText sizeLevel="4">Katılımcı Sayısı</VueText>
          <VueText sizeLevel="4">{{ summary.attenderCount }}</VueText>
        </li>
        <li>
          <VueText sizeLevel="4">Doğru Sayısı</VueText>
          <VueText sizeLevel="4">{{ summary.correctAnswer }}</VueText>
        </li>
        <li>
          <VueText sizeLevel="4">Yanlış Sayısı</VueText>
          <VueText sizeLevel="4">{{ summary.wrongAnswer }}</VueText>
        </li>
        <li>
          <VueText sizeLevel="4">Kazanılan Puan</VueText>
          <VueText sizeLevel="4">{{ summary.point }}</VueText>
        </li>
      </ul>
      <button class="summary-area-button" @click="goToPlayWin">
        <VueText sizeLevel="4" weightLevel="5">DETAYLARI GÖR</VueText>
      </button>
    </div>
  </div>
</template>
<script>
import { Gamification } from '@/services/Api/index';
import VueIcon from '@/components/shared/VueIcon/VueIcon.vue';
import { ICON_VARIABLES } from '@/constants/component.constants';
import RoutesSecure from '@/router/routes/RoutesSecure';
import RoutesRoot from '@/router/routes/RoutesRoot';
import VueText from '@/components/shared/VueText/VueText.vue';
export default {
  name: 'BrandCompetitionSummary',
  components: {
    VueText,
    VueIcon,
  },
  data() {
    return {
      summary: null,
      summaryOpen: false,
    };
  },
  computed: {
    icons() {
      return ICON_VARIABLES;
    },
  },
  created() {
    Gamification.getMarathonSummary().then(res => {
      if (res.data && res.data.Data && res.data.Data.history) {
        this.summary = res.data.Data.history;
      } else {
        //mock data
        // this.summary = {
        //   surveyName: 'Bil Bakalım / 22.05.2020',
        //   rank: '9000',
        //   attenderCount: 14292,
        //   correctAnswer: 9583,
        //   wrongAnswer: 4709,
        //   point: 50,
        //   gameType: 18,
        // };
      }
    });
  },
  methods: {
    showSummary() {
      this.summaryOpen = !this.summaryOpen;
    },
    goToPlayWin() {
      if (this.$route.fullPath !== `${RoutesRoot.Secure.path}/${RoutesSecure.PlayAndWin.path}`) {
        this.$router.push(`${RoutesRoot.Secure.path}/${RoutesSecure.PlayAndWin.path}`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.marathon-summary-wrapper {
  width: 100%;
  color: palette-color-level('white', 100);
  height: palette-space-level(50);
  transition: height 0.5s ease-out;
  overflow: hidden;
  border-radius: 5px;
  .summary-area {
    text-align: center;
    &-list {
      list-style-type: none;
      padding: 0 palette-space-level(15);
      li {
        display: flex;
        justify-content: space-between;
        margin-bottom: palette-space-level(10);
      }
    }
    &-button {
      width: 150px;
      border-radius: palette-radius-level(11);
      border: 1.5px solid palette-color-level('purple', 10);
      margin: palette-space-level(10) auto palette-space-level(5);
      padding: palette-space-level(12) 0;
      background-color: palette-color-level('white', 100);
      cursor: pointer;
    }
  }
  &.summary-open {
    height: 265px;
  }
  &-collapsible {
    cursor: pointer;

    padding: palette-space-level(15);
    height: palette-space-level(50);
    margin-bottom: palette-space-level(10);
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-caret {
      transition: transform 0.3s ease-out;
      &.caret-down {
        transform: rotateZ(90deg);
      }
    }
  }
}
</style>
